var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14598 4.14592C9.19242 4.09935 9.2476 4.06241 9.30834 4.0372C9.36909 4.012 9.43421 3.99902 9.49998 3.99902C9.56575 3.99902 9.63087 4.012 9.69161 4.0372C9.75236 4.06241 9.80753 4.09935 9.85398 4.14592L17.177 11.4699C17.3174 11.6105 17.3963 11.8012 17.3963 11.9999C17.3963 12.1987 17.3174 12.3893 17.177 12.5299L9.85398 19.8539C9.76009 19.9478 9.63275 20.0005 9.49998 20.0005C9.3672 20.0005 9.23986 19.9478 9.14598 19.8539C9.05209 19.76 8.99935 19.6327 8.99935 19.4999C8.99935 19.3671 9.05209 19.2398 9.14598 19.1459L16.293 11.9999L9.14598 4.85392C9.09941 4.80747 9.06247 4.7523 9.03727 4.69155C9.01206 4.63081 8.99908 4.56568 8.99908 4.49992C8.99908 4.43415 9.01206 4.36903 9.03727 4.30828C9.06247 4.24754 9.09941 4.19236 9.14598 4.14592Z",
    fill: "#178477"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRightArrow);
export default __webpack_public_path__ + "static/media/green-right-arrow.deb02af4aa25b2af45117b0c37bfe1a3.svg";
export { ForwardRef as ReactComponent };